import { render, staticRenderFns } from "./VehicleInformationSummary.vue?vue&type=template&id=f96eaa5e&"
import script from "./VehicleInformationSummary.vue?vue&type=script&lang=js&"
export * from "./VehicleInformationSummary.vue?vue&type=script&lang=js&"
import style0 from "./VehicleInformationSummary.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
